<template>
	<div ref="wrapper">
		<slot></slot>
	</div>
</template>

<script>
import BScroll from 'better-scroll'

export default {
	name: 'scroll',
	props: {
		probeType: {
			type: Number,
			default: 1,
		},
		click: {
			type: Boolean,
			default: true,
		},
		data: {
			type: Array,
			default: null,
		},
		listenScroll: {
			type: Boolean,
			default: false,
		},
		pullup: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {}
	},
	mounted() {
		setTimeout(() => {
			this._initScroll()
		}, 20)
	},
	methods: {
		_initScroll() {
			if (!this.$refs.wrapper) {
				return
			}
			this.scroll = new BScroll(this.$refs.wrapper, {
				probeType: this.probeType,
				click: this.click,
			})
			if (this.listenScroll) {
				let _this = this
				this.scroll.on('scroll', pos => {
					_this.$emit('scroll', pos)
				})
			}
			if (this.pullup) {
				this.scroll.on('scrollEnd', () => {
					if (this.scroll.y <= this.scroll.maxScrollY + 50) {
						this.$emit('scrollToEnd')
					}
				})
			}
		},
		enable() {
			this.scroll && this.scroll.enable()
		},
		disable() {
			this.scroll && this.scroll.disable()
		},
		refresh() {
			this.scroll && this.scroll.refresh()
		},
		scrollTo() {
			this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments)
		},
		scrollToElement() {
			this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments)
		},
	},
	watch: {
		data() {
			this.$nextTick(() => {
				this.refresh()
			})
		},
	},
	computed: {},
	components: {},
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/base/scroll/scroll.vue